"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var context_1 = require("../context");
var utils_1 = require("../utils");
var stableSort_1 = require("../utils/stableSort");
function getDefaultComparator(columnId) {
    return utils_1.Ordering.natural().nullsLast().fromMappedField(function (o) { return o[columnId]; });
}
function getComparator(sortOrder, options) {
    var _a = (options || {}).customComparators, customComparators = _a === void 0 ? {} : _a;
    var field = sortOrder.columnId, direction = sortOrder.direction;
    var comparator = customComparators[field] || getDefaultComparator(field);
    if (direction === context_1.SortDirection.Desc) {
        var ascComparator_1 = comparator;
        comparator = function (a, b) { return ascComparator_1(b, a); };
    }
    return comparator;
}
function useClientSorting(data, options) {
    var _a = context_1.useListingContext().sorting, sortOrder = _a.sortOrder, setSortOrder = _a.setSortOrder;
    var comparator = React.useMemo(function () {
        if (!sortOrder) {
            return undefined;
        }
        return getComparator(sortOrder, options);
    }, [sortOrder, options && options.customComparators]);
    var sorted = React.useMemo(function () {
        if (!comparator) {
            return data;
        }
        return stableSort_1.default(data, comparator);
    }, [data, comparator]);
    return { sorted: sorted, sortOrder: sortOrder, setSortOrder: setSortOrder };
}
exports.default = useClientSorting;
//# sourceMappingURL=useClientSorting.js.map